export default __webpack_public_path__ + "static/media/lead-4.bfa9ee4f.png";